/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { DateRange } from "react-date-range";
import { FaCalendarAlt } from "react-icons/fa";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const PAGE_SIZE = 10;

const AdvanceBookings = () => {
  const [data, setData] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [name, setName] = useState("");
const [mobile, setMobile] = useState("");
const [booking, setBooking] = useState("");
  const [page, setPage] = useState(1);

  // 📅 Date Range State
  const [dateRange, setDateRange] = useState([
    { startDate: null, endDate: null, key: "selection" },
  ]);

  const [tempRange, setTempRange] = useState(dateRange);
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);
const API_URL = process.env.REACT_APP_API_URL;
  // 📡 Fetch
  const fetchData = async () => {
    const res = await axios.get(
      `${API_URL}/api/reports/upcoming-bookings`
    );

    const sorted = (res.data.data || []).sort(
      (a, b) => new Date(a.EventDate) - new Date(b.EventDate)
    );

    setData(sorted);
    setFiltered(sorted);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ❌ Close calendar on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 🔍 FILTER LOGIC (Search + Date)
useEffect(() => {
  const { startDate, endDate } = dateRange[0];

  const end = endDate
    ? new Date(endDate.getTime() + 86400000 - 1)
    : null;

  const result = data.filter((item) => {
    const matchName = item.FullName
      ?.toLowerCase()
      .includes(name.toLowerCase());

    const matchMobile = item.Mobile?.includes(mobile);

    const matchBooking = item.BookingCode
      ?.toLowerCase()
      .includes(booking.toLowerCase());

    const itemDate = new Date(item.EventDate);

    const matchDate =
      startDate && endDate
        ? itemDate >= startDate && itemDate <= end
        : true;

    return matchName && matchMobile && matchBooking && matchDate;
  });

  setFiltered(result);
  setPage(1);
}, [name, mobile, booking, dateRange, data]);

  // 📄 Pagination
  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const paginatedData = filtered.slice(
    (page - 1) * PAGE_SIZE,
    page * PAGE_SIZE
  );

  // 📥 Export
  const exportToExcel = () => {
    const rows = filtered.map((item) => ({
      Date: new Date(item.EventDate).toLocaleDateString(),
      Customer: item.FullName,
      Mobile: item.Mobile,
      Booking: item.BookingCode,
      Event: item.EventName,
      Hall: item.Hall,
      Total: item.GrandTotal,
      Advance: item.AdvancePaid,
      Pending: item.PendingAmount,
    }));

    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Bookings");

    const buffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(new Blob([buffer]), "UpcomingBookings.xlsx");
  };

  const { startDate, endDate } = dateRange[0];

  return (
    <div className="max-w-7xl mx-auto bg-white shadow-2xl rounded-3xl p-8">

      {/* Header */}
      <h2 className="text-3xl font-bold mb-6 text-center flex items-center justify-center gap-2">
        <FaCalendarAlt className="text-blue-600" />
        Upcoming Bookings
      </h2>

      {/* 🔍 FILTER CARD */}
      <div className="bg-white shadow-xl rounded-2xl p-6 mb-8 relative">
        <h3 className="text-lg font-semibold text-gray-700 mb-4">
          Search & Filters
        </h3>

        <div className="grid md:grid-cols-3 gap-6">

          {/* Search */}
          <div>
    <label className="text-sm text-gray-600 mb-1">
      Customer Name
    </label>
    <input
      type="text"
      placeholder="Enter name"
      value={name}
      onChange={(e) => setName(e.target.value)}
      className="px-4 py-2 border rounded-xl w-full focus:ring-2 focus:ring-emerald-500"
    />
  </div>

  {/* Mobile */}
  <div>
    <label className="text-sm text-gray-600 mb-1">
      Mobile
    </label>
    <input
      type="text"
      placeholder="Enter mobile"
      value={mobile}
      onChange={(e) => setMobile(e.target.value)}
      className="px-4 py-2 border rounded-xl w-full focus:ring-2 focus:ring-emerald-500"
    />
  </div>

  {/* Booking Code */}
  {/* <div>
    <label className="text-sm text-gray-600 mb-1">
      Booking Code
    </label>
    <input
      type="text"
      placeholder="Enter booking code"
      value={booking}
      onChange={(e) => setBooking(e.target.value)}
      className="px-4 py-2 border rounded-xl w-full focus:ring-2 focus:ring-emerald-500"
    />
  </div> */}

          {/* Date Range */}
          <div className="relative">
            <label className="text-sm text-gray-600 mb-1">
              Date Range
            </label>

            <button
              onClick={() => {
                setTempRange(dateRange);
                setShowCalendar(!showCalendar);
              }}
              className="flex items-center gap-2 px-4 py-2 border rounded-xl w-full"
            >
              <FaCalendarAlt className="text-gray-400" />
              {startDate && endDate
                ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
                : "Select date range"}
            </button>

            {showCalendar && (
              <div
                ref={calendarRef}
                className="absolute z-50 mt-2 bg-white shadow-2xl rounded-xl p-4"
              >
                <DateRange
                  editableDateInputs
                  moveRangeOnFirstSelection={false}
                  ranges={tempRange}
                  onChange={(item) =>
                    setTempRange([item.selection])
                  }
                  rangeColors={["#10b981"]}
                />

                <div className="flex justify-between mt-3">
                  <button
                    onClick={() => {
                      setDateRange([
                        { startDate: null, endDate: null, key: "selection" },
                      ]);
                      setShowCalendar(false);
                    }}
                    className="px-3 py-1 border rounded-lg"
                  >
                    Default
                  </button>

                  <div className="flex gap-2">
                    <button
                      onClick={() => setShowCalendar(false)}
                      className="px-3 py-1 border rounded-lg"
                    >
                      Cancel
                    </button>

                    <button
                      onClick={() => {
                        setDateRange(tempRange);
                        setShowCalendar(false);
                      }}
                      className="px-3 py-1 bg-emerald-500 text-white rounded-lg"
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

        </div>
      </div>

      {/* 📊 Entry + Export */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4 p-3 bg-gray-50 rounded-xl">
        <p className="text-sm text-gray-600">
          Showing
          <span className="font-semibold text-gray-900 mx-1">
            {filtered.length}
          </span>
          of
          <span className="font-semibold text-gray-900 mx-1">
            {data.length}
          </span>
          entries
        </p>

        <button
          onClick={exportToExcel}
          className="bg-emerald-600 text-white px-4 py-2 rounded-lg"
        >
          Export .xlsx
        </button>
      </div>

      {/* 📋 Table */}
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="bg-gradient-to-r from-blue-600 to-emerald-500 text-white ">
              <th className="p-3">Date</th>
              <th>Customer</th>
              <th>Booking</th>
              <th>Event</th>
              <th>Hall</th>
              <th>Total</th>
              <th>Advance</th>
              <th>Pending</th>
            </tr>
          </thead>

          <tbody>
            {paginatedData.map((row, i) => (
              <tr key={i} className="border-b hover:bg-emerald-50 text-center">
                <td className="p-3">
                  {new Date(row.EventDate).toLocaleDateString('en-GB')}
                </td>

                <td>
                  {row.FullName}
                  <div className="text-xs text-gray-400">
                    {/* {row.Mobile} */}
                  </div>
                </td>

                <td>{row.BookingCode}</td>
                <td>{row.EventName}</td>
                <td>{row.Hall}</td>

                <td>{row.GrandTotal}</td>
                <td className="text-green-600">{row.AdvancePaid}</td>
                <td className="text-red-600">{row.PendingAmount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 📄 Pagination */}
      <div className="flex justify-center mt-6 gap-4">
        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          className="px-4 py-1 border rounded-lg"
        >
          Prev
        </button>

        <span>
          Page {page} / {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
          className="px-4 py-1 border rounded-lg"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AdvanceBookings;